import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MenuItemModel} from '../../../models/menu-item.model';
import {ItemService} from '../../../../provider/item.service';
import {MenuItemBulletListModel} from '../../../models/menu-item-bullet-list.model';
import {MenuTitleDescriptionModel} from '../../../models/menu-title-description.model';

@Component({
  selector: 'c-additional-info',
  templateUrl: './additional-info.popup.html',
  styleUrls: ['./additional-info.popup.scss']
})
export class AdditionalInfoPopup {

  constructor(@Inject(MAT_DIALOG_DATA) public data: MenuItemModel,
              private dialogRef: MatDialogRef<AdditionalInfoPopup>,
              private itemService: ItemService) {
  }

  close() {
    this.dialogRef.close(this.data);
  }

  updateData() {
    this.itemService.setItem(this.data);
    this.itemService.putData(this.data);
  }

  postBulletList() {
    this.updateData();
    if (this.data.show_bullet_list) {
      if (this.itemService.bulletList_change$.getValue().length == 0) {
        const bulletList: MenuItemBulletListModel = new MenuItemBulletListModel();
        bulletList.menu_item_id = this.data.id;
        this.itemService.postBulletListData(bulletList);
      }
    }
  }

  postTitleDes() {
    this.updateData();
    if (this.data.show_title_and_description) {
      if (this.itemService.titleDescription_change$.getValue().length == 0) {
        const titleDes: MenuTitleDescriptionModel = new MenuTitleDescriptionModel();
        titleDes.menu_item_id = this.data.id;
        this.itemService.postTitleDesData(titleDes);
      }
    }
  }
}
